import { render, staticRenderFns } from "./plugin.vue?vue&type=template&id=299ca83e&"
import script from "./plugin.vue?vue&type=script&lang=ts&"
export * from "./plugin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports